import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../../../libs/shared/core/src/models/api/paletteModel';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon, IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {VisuallyHidden} from '../../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';

/*
 * Props.
 */

interface ComposerInfoBannerProps {
  onDismiss: () => void;
  color: PaletteColorsEnum;
  iconName: IconName;
  iconColor?: string;
}

/*
 * Style.
 */

interface BannerStyleProps {
  $color: PaletteColorsEnum;
}
const StyledBannerDiv = styled.div<BannerStyleProps>`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: 'icon content close';

  margin: 10px 10px 0 10px;
  padding: 4px 4px 4px 8px;

  background-color: ${(p) => p.theme.palette[p.$color].shade20};
  border-radius: 8px;
`;

const StyledIconDiv = styled.div`
  grid-area: icon;

  margin-top: 5px;
`;

const StyledContentDiv = styled.div`
  grid-area: content;

  margin: 0px 2px 0px 8px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 6px;
`;

const StyledCloseButton = styled(ChromelessButton)`
  grid-area: close;
  padding: 5px;
  border-radius: 5px;
  color: ${(p) => p.theme.greys.shade70};
  height: 26px;
  width: 26px;

  &:hover {
    background-color: ${(p) => p.theme.alphas.gray10};
  }
`;

/*
 * Component.
 */

export const ComposerInfoBanner: FC<PropsWithChildren<ComposerInfoBannerProps>> = (props) => (
  <StyledBannerDiv $color={props.color}>
    <StyledIconDiv>
      <Icon name={props.iconName} color={props.iconColor} size={16} />
    </StyledIconDiv>
    <StyledContentDiv>{props.children}</StyledContentDiv>
    <StyledCloseButton onClick={props.onDismiss}>
      <Icon name="closeSmall" />
      <VisuallyHidden>
        <Trans id="banner-close">Close</Trans>
      </VisuallyHidden>
    </StyledCloseButton>
  </StyledBannerDiv>
);
